import React from 'react';
import {connect} from 'react-redux';
import CameBackFromAbroad from './CameBackFromAbroad';
import Config from '../../../Config';
import { dwhViewUsageAbroad } from 'app/Components/Page/SelfCarePage/partials/header/dwhReports';
import {isNullOrEmpty} from '../../../utilities/StringHelpers/StringHelpers';
const SelfCareCostumerNoAbroadFuturePackageMain = (props) => {
  console.log(props)
 function reportDwh (){
  const customerName = props.subscriber.productFirstName+" "+ props.subscriber.productLastName
  const subscriber = props.subscriber.productSubscriberNo
  const idNumber = ""
  const ban = props.subscriber.ban
  const psid = null
  const crmId= null
  const param1 = subscriber
  const param9 =null
  const param10=null
  dwhViewUsageAbroad(customerName,subscriber,idNumber, ban , psid, crmId,param1,param9,param10)
 }
  const titleBeforeAbroad = props.iContent.titleBeforeAbroad.value;
  const btnTextBeforeAbroad = props.iContent.btnTextBeforeAbroad.value;
  const titleAfterAbroad = props.iContent.titleAfterAbroad.value;
  const btnTextAfterAbroad = props.iContent.btnTextAfterAbroad.value;
  const buttonLinkAfterAbroad = props.iContent.btnLink.value?.url;
  const icon = Config.epiBaseUrl + props.iContent.icon.value?.url;

  const isPreConditionsAreValid = () => {
    var userUsageCompleted=props.userUsageDataCompleted || !isNullOrEmpty(props.userUsageData)
    return userUsageCompleted && props.abroadPackReqCompleted && props.subscriber?.abroadSocInd === 'N';
  };

  const isBeforeAbroad = () => {
    return (
      !props.hasPreviousUsage && props.effPackage?.length === 0 && Array.isArray(props.abroadPackages) && props.abroadPackages?.length > 0
    );
  };

  const isAfterAbroad = () => {
    return props.hasPreviousUsage || props.effPackage?.length > 0;
  };

  return (
    isPreConditionsAreValid() && (
      <>
        {isBeforeAbroad() &&(
          <CameBackFromAbroad
          text={titleBeforeAbroad}
          icon={icon}
          btnText={btnTextBeforeAbroad}
          isAfter={false}
          reportDwh={reportDwh}
          />
           )}

        {isAfterAbroad() && (
          <CameBackFromAbroad
            text={titleAfterAbroad}
            icon={icon}
            btnText={btnTextAfterAbroad}
            btnLink={buttonLinkAfterAbroad}
            isAfter={true}
            reportDwh={reportDwh}
          />
          )}
      </>
    )
  );
};

const mapStateToProps = (state) => ({
  effPackage: state.selfcarePage.selectedSubscriber?.abroadUsage?.data?.effectivePackagesToShow,
  abroadPackages: state.selfcarePage.selectedSubscriber?.abroadPackages?.regularPackages,
  userUsageDataCompleted: state.selfcarePage.selectedSubscriber?.abroadUsage?.status == 'fulfilled',
  abroadPackReqCompleted: state.selfcarePage.selectedSubscriber?.abroadPackages?.status == 'fulfilled',
  subscriber: state.selfcarePage.selectedSubscriber,
  hasPreviousUsage: state.selfcarePage.selectedSubscriber?.abroadUsage?.data?.hasPreviousUsage,
  hasCurrentUsage: state.selfcarePage.selectedSubscriber?.abroadUsage?.data?.hasCurrentUsage,
  userUsageData: state.selfcarePage.selectedSubscriber?.abroadUsage?.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareCostumerNoAbroadFuturePackageMain);
